export const getEqlWhereString = (eql?: string) => {
  if (!eql) {
    return undefined;
  }

  const whereClause = eql.split('where ').slice(1).join('where ');

  return whereClause === '' ? undefined : whereClause;
};
